import React from "react";
import {Alert} from "reactstrap";

interface AuthErrorProps {
  error: string | null;
  onClose?: () => void;
}

const AuthError: React.FC<AuthErrorProps> = ({error, onClose}) => {
  if (!error) {
    return null;
  }

  return (
    <Alert color="danger" isOpen={!!error} toggle={onClose}>
      <span className="alert-inner--icon">
        <i className="tim-icons icon-alert-circle-exc" />
      </span>
      <span className="alert-inner--text ml-1">{error}</span>
    </Alert>
  );
};

export default AuthError;
